import * as React from "react";
import type { SVGProps } from "react";
const SvgHourglassSimpleMedium = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 256 256"
    fill={props.color || "#746A80"}
    {...props}
  >
    <path d="M211.18 196.56 139.57 128l71.61-68.56a2 2 0 0 1 .13-.13A16 16 0 0 0 200 32H56a16 16 0 0 0-11.3 27.31l.12.13L116.43 128l-71.61 68.56-.12.13A16 16 0 0 0 56 224h144a16 16 0 0 0 11.32-27.31 2 2 0 0 1-.14-.13M97.79 88h60.42L128 116.92ZM200 48l-25.08 24H81.08L56 48ZM56 208l64-61.26V168a8 8 0 0 0 16 0v-21.26L200 208Z" />
  </svg>
);
export default SvgHourglassSimpleMedium;
